import { AdminState } from "../../redux/adminSlice";
import { sidebarLink } from "../../types/sidebarLink";

export const filterSidebarLinks = (
  links: sidebarLink[],
  admin: AdminState
): sidebarLink[] => {
  return links
    .map((link) => {
      if (link.children) {
        const filteredChildren = filterSidebarLinks(link.children, admin);
        return filteredChildren.length > 0
          ? { ...link, children: filteredChildren }
          : null;
      }

      if (link.permission && !admin.permissions.includes(link.permission))
        return null;

      return link;
    })
    .filter(Boolean) as sidebarLink[];
};
